"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * checks if an object has object type not null
 * @param o
 * @return {boolean}
 */
function isObject(o) {
    return o === Object(o);
}
exports.isObject = isObject;
function isMobileSettings() {
    return window.Wix.Utils.getDeviceType() === 'mobile';
}
exports.isMobileSettings = isMobileSettings;
function getSettingsKeyFor(desktopKey, isMobile) {
    var keyWithUpperFirst = desktopKey[0].toUpperCase() + desktopKey.slice(1);
    return isMobile ? "mobile" + keyWithUpperFirst : desktopKey;
}
exports.getSettingsKeyFor = getSettingsKeyFor;
function hideBodyOverflow(isOpen, className) {
    if (typeof document === 'undefined') {
        return;
    }
    try {
        if (isOpen) {
            !document.body.classList.contains(className) &&
                document.body.classList.add(className);
        }
        else {
            document.body.classList.remove(className);
        }
    }
    catch (e) { }
}
exports.hideBodyOverflow = hideBodyOverflow;
//# sourceMappingURL=utils.js.map